// mutations 变量名

export const SET_COURSE = 'SET_COURSE';
export const SET_USERGUID = 'SET_USERGUID';
export const UPDATE_USERGUID = 'UPDATE_USERGUID';
export const SET_BEFORELOGINPAGE = 'SET_BEFORELOGINPAGE';
export const UPDATE_BEFORELOGINPAGE = 'UPDATE_BEFORELOGINPAGE';
export const RECORD_USERINFO = 'RECORD_USERINFO';
export const REMOVE_USEINFO = 'REMOVE_USEINFO';
export const REMOVE_USERGUID = 'REMOVE_USERGUID';
export const RECORD_THIRDPARTY = 'RECORD_THIRDPARTY';
export const RECORD_THIRDPARTYINFO = 'RECORD_THIRDPARTYINFO';
export const RECORD_SYSTEMINFO = 'RECORD_SYSTEMINFO';
export const LOGIN_IN = 'LOGIN_IN';
export const UPDATE_AUTHORTOKEN = 'UPDATE_AUTHORTOKEN';
export const REMOVE_AUTHORTOKEN = 'REMOVE_AUTHORTOKEN';
export const UPDATE_ORDERINFO = 'UPDATE_ORDERINFO';
export const REMOVE_ORDERINFO = 'REMOVE_ORDERINFO';
export const UPDATE_ORDERINQUIRESTATE = 'UPDATE_ORDERINQUIRESTATE';
export const REMOVE_ORDERINQUIRESTATE = 'REMOVE_ORDERINQUIRESTATE';
export const UPDATE_ORDERVTIME = 'UPDATE_ORDERVTIME';
export const REMOVE_ORDERVTIME = 'REMOVE_ORDERVTIME';
export const SET_SHOWMASKFLAG = 'SET_SHOWMASKFLAG';
export const RECORD_ROUTERHISTORY = 'RECORD_ROUTERHISTORY';
export const UPDATE_FIRSTENTER = 'UPDATE_FIRSTENTER';
export const UPDATE_FIRSTBACK = 'UPDATE_FIRSTBACK';



// WEBPACK FOOTER //
// ./src/store/mutations-types.js